export const PROJECT_NAME = process.env.NEXT_PUBLIC_SEO_TITLE_NAME;
export const SLOGAN_TEXT = "Агрегатор по\u00A0поиску автомобилей";
export const SLOGAN_ADDITIONAL_TEXT = "со всего мира";